import axios from 'axios';
import cookie from 'js-cookie';

import { listApi, detailsApi, createApi, updateApi, deleteApi, searchApi } from './index';

const bookSubdomain = 'books';
const activitySubdomain = 'activities';
let axiosConfig = {
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    "authorization": "Token " + cookie.get('token')
  }
};

export function fetchBooksForInstrument(instrumentId) {
  const url = `${process.env.REACT_APP_SERVER_URL}/books/?instrument=${instrumentId}`;
  return axios.get(url).then(res => res.data);
}


export function fetchActivitiesMoreList(limit, offset) {
  const url = `${process.env.REACT_APP_SERVER_URL
    }/${activitySubdomain}/?limit=${limit}&offset=${offset}`;
  return axios.get(url, axiosConfig).then(res => res.data);
}

export function fetchSearchActivitiesMoreList(limit, offset, search) {
  const url = `${process.env.REACT_APP_SERVER_URL
    }/${activitySubdomain}/?limit=${limit}&offset=${offset}&search=${search}`;
  return axios.get(url, axiosConfig).then(res => res.data);
}

export function fetchSearchActivities(query) {
  const url = `${process.env.REACT_APP_SERVER_URL
    }/${activitySubdomain}/${query}`;
  return axios.get(url, axiosConfig).then(res => res.data);
}

export const fetchBookDetails = id => detailsApi({ subdomain: bookSubdomain, id });

export const fetchBooks = () => listApi({ subdomain: bookSubdomain });

export const deleteBook = id => deleteApi({ subdomain: bookSubdomain, id });

export const searchBooks = ({ search }) => searchApi({ subdomain: bookSubdomain, search });

export const fetchActivityDetails = id => detailsApi({ subdomain: activitySubdomain, id });

export const fetchActivities = () => listApi({ subdomain: activitySubdomain });

export const searchActivities = ({ search }) => searchApi({ subdomain: activitySubdomain, search});

export const addNewActivity = payload => createApi({ subdomain: activitySubdomain, payload });

export const deleteActivity = id => deleteApi({ subdomain: activitySubdomain, id });

export const updateActivityDetails = payload =>
  updateApi({ subdomain: activitySubdomain, payload });
